// What each browser says when a lazily loaded page's code could not be
// downloaded: Chromium, Safari and Firefox respectively.
const CHUNK_LOAD_MESSAGES = [
  /Failed to fetch dynamically imported module/i,
  /Importing a module script failed/i,
  /error loading dynamically imported module/i,
];

/**
 * Whether an error means a page's code never arrived — the connection dropped,
 * or a release replaced the files an open tab still points at — rather than a
 * fault in the page itself. Reloading fetches it again.
 */
export const isChunkLoadError = (error: unknown): boolean => {
  const message = error instanceof Error ? error.message : typeof error === 'string' ? error : '';
  return CHUNK_LOAD_MESSAGES.some((pattern) => pattern.test(message));
};
